// extracted by mini-css-extract-plugin
export var item = "ArtImage-module--item--835cd";
export var picture = "ArtImage-module--picture--2c22f";
export var image = "ArtImage-module--image--82ab4";